import React from 'react'
import { SiteHeader as Component } from '@swp/components'

export default function SiteHeader(props) {
return (
  <Component className="--spacing4 --size-L" type={"SiteHeader"} item={{"color":"rgba(255,255,255,1)","colorHover":"rgba(255,255,255,0.5)","className":"fs--18 w--400"}} title={{"color":"rgba(255,255,255,1)","content":"Dárkové poukazy","className":"fs--30 w--500 ls--002"}} social={{"twitter":"saywebpage","facebook":"saywebpage","instagram":"saywebpage"}} backgroundColor={"rgba(24,25,29,1)"} button={{"className":"btn-box"}} />
)
}